<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Arrow.16"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_983" data-name="Group 983">
      <path
        id="Path_8372"
        data-name="Path 8372"
        d="M5,12H19M10,7,5,12m5,5L5,12"
        fill="none"
        :stroke="clr ? clr : '#323232'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8373" data-name="Path 8373" d="M0,0H24V24H0Z" fill="none" />
  </svg>
</template>
